import React from 'react';

const Byline = props => {

    return (
        <div className="article-wrapper byline">
            <p>{props.byline}</p>
        </div>
    );
}

export default Byline;
